module.exports = __webpack_public_path__ + "img/money-white.0eafc089.svg";